import * as React from 'react';
import { Col, Input } from 'reactstrap';
import Row from 'reactstrap/lib/Row';
import { TR } from 'src/TextRes';
import { CourseProviderEdit } from '../../api';
import { EditingName } from '../../views/cpProfile/CPProfile';
import { CPItemEditComponent, EditState } from './CPItemEditComponent';
import { CPItemWarning } from './CPItemWarning';

export interface CPNameProps {
    courseProvider: CourseProviderEdit;
    cancelHandler: () => void;
    className?: string;
    editHandler: () => void;
    editItemKey: string | undefined;
    error?: boolean;
    errorMessage?: string;
    saveCourseProviderName: (a: string) => void;
}

export interface CPNameState {
    name: string;
    validationError?: boolean;
}

export default class CPName extends React.PureComponent<CPNameProps, CPNameState> {
    constructor(props: CPNameProps) {
        super(props);
        this.state = {
            name: '',
            validationError: false,
        };
    }

    public componentWillReceiveProps() {
        this.setState({
            name: this.props.courseProvider.Name,
        });
    }

    public render() {
        return (
            <CPItemEditComponent
                name={TR.cPName_name_org}
                editHandler={this.props.editHandler}
                saveHandler={() => {
                    if (this.state.name.length < 3) {
                        this.setState({ validationError: true });
                    } else {
                        this.setState({ validationError: false }, () => {
                            this.props.saveCourseProviderName(this.state.name);
                        });
                    }
                }}
                cancelHandler={this.props.cancelHandler}
                content={this.renderContent()}
                contentEdit={this.renderContentEdit()}
                editState={this.editStateThisComponent()}
                error={this.props.error}
                errorMessage={this.props.errorMessage}
                validationError={this.state.validationError}
                validationMessage={this.state.validationError ? TR.cPName_check_data : ''}
            />
        );
    }

    private editStateThisComponent() {
        let myEditState: EditState;
        if (this.props.editItemKey === EditingName.CPName) {
            myEditState = EditState.This;
        } else if (this.props.editItemKey === undefined) {
            myEditState = EditState.None;
        } else {
            myEditState = EditState.Other;
        }
        return myEditState;
    }

    private renderContent = () => {
        if (!this.props.courseProvider.Name) {
            return (
                <Col className="mt-2">
                    <CPItemWarning errorMessage={TR.cPName_fill_out} />
                </Col>
            );
        } else {
            return <Col className="mb-1 mt-1">{this.props.courseProvider.Name}</Col>;
        }
    };

    private renderContentEdit = () => {
        return (
            <>
                <Row>
                    <Col md={12} className=" mb-1">
                        <Input
                            style={{ border: this.state.name.length < 3 ? '1px solid red' : 'inherit' }}
                            bsSize={'sm'}
                            autoFocus={true}
                            id="name"
                            name="name"
                            type="text"
                            placeholder={TR.cPName_name_org}
                            defaultValue={this.props.courseProvider.Name}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                this.setState({ name: e.currentTarget.value });
                            }}
                        />
                    </Col>
                    <Col md={12}>
                        <span style={{ fontSize: '14px', color: '#666' }}>{TR.cPName_your_name}</span>
                    </Col>
                </Row>
            </>
        );
    };
}



// WEBPACK FOOTER //
// ./src/components/cpProfileComponent/CPName.tsx